module.exports = __webpack_public_path__ + "static/media/monica_full.51488d03.png";